import { XbpmContext } from '../../services';
export var AuthLogin = function () {
    XbpmContext.getContext().authService.login();
    return null;
};
//# sourceMappingURL=AuthLogin.js.map